<style scoped>
    .table-header{
        padding: 6px;
        text-align: center;
        font-weight: bold;
    }
</style>
<template>
    <div>
        <Table :size="size" :columns="columns" :data="contract_stocks" :loading="loading">
            <div slot="header" class="table-header">采购合同到货情况</div>
            <div class="table-header" slot="footer">
                <Page
                    size="small"
                    show-total
                    :current="page_info.current"
                    :total="page_info.total"
                    :page-size="page_info.page_size"
                    @on-change="pageChange">
                </Page>
            </div>
        </Table>
    </div>
</template>
<script>
    import ViewerItem from '../../components/viewer/item';
    import StockUtil from '../libs/util';
    export default {
        components: { ViewerItem },
        /*
        * 存货相关的合同的到货情况
        * */
        props: {
            stock_id: {
                type: Number,
            },
            size: {
                type: String,
                default: 'default'
            }
        },
        data(){
            return {
                params: {
                    page: 1,
                    per_page: 10
                },
                page_info: {
                    current: 1,
                    total: 0,
                    page_size: 10
                },
                loading: false,
                contract_stocks: [],
                columns: [
                    {
                        title: '采购合同',
                        align: 'center',
                        width: 120,
                        render: (h, params)=>{
                            const row = params.row;
                            const contract_id = row.contract_id;
                            if(contract_id > 0){
                                return h(ViewerItem, {
                                    props: {
                                        type: 'Contract',
                                        model_id: contract_id
                                    },
                                    'class': {
                                        link: true
                                    }
                                }, row.contract_uid);
                            }else{
                                return h('div', [
                                    h('span', row.contract_uid),
                                    h('div', {
                                        'class': {'color-error': true}
                                    }, '未关联合同'),
                                ]);
                            }
                        }
                    },
                    {
                        title: '采购数量',
                        align: 'right',
                        width: 80,
                        render: (h, params)=>{
                            const row = params.row;
                            return h('span', Util.formatNumber(row.qty));
                        }
                    },
                    {
                        title: '到货数量',
                        align: 'right',
                        width: 80,
                        render: (h, params)=>{
                            const row = params.row;
                            return  h('span', Util.formatNumber(row.arrived_qty));
                        }
                    },
                    {
                        title: '剩余数量',
                        align: 'right',
                        width: 80,
                        render: (h, params)=>{
                            const row = params.row;
                            return  h('span', Util.formatNumber(math.eval(`${row.qty} - ${row.arrived_qty}`).toFixed(2)));
                        }
                    },
                    {
                        title: '采购单价',
                        align: 'right',
                        width: 80,
                        render: (h, params)=>{
                            return h('div', Util.formatPrice(params.row.unit_price));
                        }
                    },
                    {
                        title: '总价',
                        align: 'right',
                        width: 100,
                        render: (h, params)=>{
                            return h('div', Util.formatPrice(params.row.total_price));
                        }
                    },
                    {
                        title: '供应商',
                        align: 'center',
                        width: 120,
                        render: (h, params)=>{
                            return h('div', params.row.payee_company);
                        }
                    },
                    {

                        title: '合同申请时间',
                        align: 'center',
                        width: 100,
                        render: (h, params)=>{
                            let row = params.row;
                            return h('span', this.$util.formatTime(row.contract_created_at) || '-');
                        }
                    },
                    {
                        title: '预计到货时间',
                        align: 'center',
                        key: 'estimate_arrival_time',
                        width: 100,
                        render: (h, params)=>{
                            let row = params.row;
                            return h('span', row.estimate_arrival_time || '-');
                        }
                    }
                ]
            }
        },
        computed: {
            //
        },
        created(){
            this.getStockContract();
        },
        mounted(){
            //
        },
        methods: {
            getStockContract(){
                if (this.loading) return;
                this.loading = true;
                this.$util.ajax.get(this.$util.api.stock_contracts, {
                    params: Object.assign({
                        stock_id: this.stock_id
                    }, this.params)
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    if(res.code === 1){
                        const data = res.data;
                        this.contract_stocks = data.contract_stocks;
                        this.page_info.current = data.cur_page;
                        this.page_info.page_size = data.per_page;
                        this.page_info.total = data.total_count;
                    }else{
                        this.$Modal.warning({title: '错误', content: res.msg});
                    }
                }).catch((e)=>{
                    this.$Modal.warning({title: '错误', content: e.message});
                }).finally(()=>{
                    this.loading = false;
                });
            },
            pageChange(new_page){
                this.params.page = new_page;
                this.getStockContract();
            },
        }
    }
</script>
